import axios from 'axios';
import Url from '../constants/Url';

class UserApi {
    checkSignupRequirementsMet() {
        return axios
            .get(Url().GET_CHECK_SIGNUP_REQUIREMENTS_MET)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to check signup requirements met:', ex.message);
                throw ex;
            });
    }
}

export default new UserApi();
